import { ProductCostItemSchema } from "./product-cost-item";
import { ProductImageItemSchema } from "./product-image-item";
import { z } from "zod";
import { normalizeImageUrl } from "../shared/date-validation";

export const ProductItemSchema = z.object({
  Id: z.string(),
  ProductId: z.string().optional(),
  Name: z.string(),
  Url: z.string().optional(),
  ThumbnailUrl: z.string().optional(),
  Number: z.string().optional(),
  ImageThumbName: z
    .string()
    .optional()
    .transform((value) => (value ? normalizeImageUrl(value) : undefined)),
  ReviewsCount: z.number().optional(),
  ReviewAverage: z.number().optional(),
  DisplayOrder: z.string().optional(),
  Description: z.string().optional(),
  FamilyCode: z.number().optional(),
  DescriptionHtml: z.string().optional(),
  ShortDescription: z.string().optional(),
  Overview: z.string().optional(),
  DefaultImage: ProductImageItemSchema.optional(),
  Images: ProductImageItemSchema.array().optional(),
  DefaultCost: ProductCostItemSchema.optional(),
  CostAnnual: ProductCostItemSchema.optional(),
  CostMonthly: ProductCostItemSchema.optional(),
  CostItem: ProductCostItemSchema.optional(),
});

export type ProductItemType = z.infer<typeof ProductItemSchema>;
